import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const FileExplorer = lazy(() => import('.'));

class FileExplorerComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['documentId', 'projectId', 'isAdmin', 'productType'];
    }

    render() {
        // @ts-expect-error Ignoring this for now
        // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
        const filenames: [{ filename_id: number; filename: string; keys_count: number }] | null = window.__FILENAMES;
        const documentId: string = this.jsonProp('documentId') ?? '';
        const projectId: string = this.jsonProp('projectId') ?? '';
        const isAdmin: boolean = this.jsonProp('isAdmin') ?? false;
        const projectType: number = parseInt(this.jsonProp('projectType') ?? '-1', 10);

        return (
            <AppProviders>
                <FileExplorer
                    filenames={filenames}
                    documentId={documentId}
                    projectId={projectId}
                    isAdmin={isAdmin}
                    projectType={projectType}
                />
            </AppProviders>
        );
    }
}

customElements.define('file-explorer', FileExplorerComponent);
